import { FunctionComponent } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  StyledBoxArea,
  StyledPageTitle,
  StyledContainer,
  StyledDescription,
  BackToHomepageButton,
  LoginButton,
  LoginLink,
  IconStyled,
} from "./styles";

import getOpco from "utils/getOpco";

import { configState } from "state/config-slice";
import { userState } from "state/user-slice";
import Basket from "components/IconImage/basket";

const NoAuthPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = useSelector(userState);
  const config = useSelector(configState);

  const opco = getOpco();
  const url = config.openidUrls?.find((el) => el.type === "bronze" || el.type === "gold")?.url as string;

  return (
    <StyledContainer>
      <IconStyled>
        <Basket stroke="#CCCCCC" width="100px" height="90px" />
      </IconStyled>
      <StyledPageTitle>
        <Trans i18nKey="You are not logged in" />
      </StyledPageTitle>
      <StyledDescription>
        <Trans i18nKey="Please login to see this page" />
      </StyledDescription>

      <StyledBoxArea>
        <BackToHomepageButton id="no-auth-back" onClick={() => navigate("/")} title={t("Back to homepage")} />
        {opco === "gb" ? (
          <LoginButton id="no-auth-login" onClick={() => navigate("/service-selection")} title={t("Login")} />
        ) : (
          <LoginLink data-testid="Login" href={url} rel="noreferrer" hidden={user.loggedIn}>
            {t("Login to subscribe")}
          </LoginLink>
        )}
      </StyledBoxArea>
    </StyledContainer>
  );
};

export default NoAuthPage;
